console.log('init Proteus Treatments -- 0.07');

// support for [PEACH-39]
waitForElement('body').then(doc => {
  doc.insertAdjacentHTML("afterbegin", `
  <style>
  @keyframes fadeIn {
    to {
      opacity: 1;
    }
  }
  .grid-product__price, 
  .Product_grid_item_price_new, 
  .product__price, 
  .product_price, 
  .total-price, 
  .product__price, 
  .product_price, 
  .total-price, 
  .grid-product__price, 
  .Product_grid_item_price_new, 
  [data-product-price], 
  .cart__item .cart__price{
    opacity: 0;
    animation: fadeIn 0.5s ease forwards;
    animation-delay: 0.5s;
  }
  </style>
  `);
}).catch();

// LP tracking
if(window.location.href.indexOf("/pages/email-signup") > -1 && document.referrer == ""){
  setTimeout(() => {
    gtm_add_cartAttribute("proteus-LP", "email-signup");
  }, 3000);
}

window.addEventListener("postscriptPopup", function(ev) {  
  window.dataLayer = window.dataLayer || [];
  const { values, popupName, popupId } = ev.detail;

  // ev.detail.type includes these values (hopefully others) [formSubmit, popupClose]
  
  dataLayer.push({
    'event': 'proteus_custom_event',
    'proteus_event_name': `PS ${ev.detail.type} - ${popupName} ${popupId}`,
    'proteus_event_category': "CRO",
    'page_location': window.location.href
  });

});

if(window.location.href.indexOf("gwp=active") > -1 || false || window.sessionStorage.getItem("activate [PEACH] GWP")){
  window.sessionStorage.setItem("activate [PEACH] GWP", true);

  waitForElement('body').then(doc => {
    doc.insertAdjacentHTML("afterbegin", `
    <style>
    .js-add-gwp .cart__items:before{
      content: "free mystery slime with purchase $50+";
      padding: .5rem;
      margin-bottom: .75rem;
      display: block;
      text-align: center;
      border: 2px solid;
      font-weight: 900;
      border-radius: 125px;
    }
    </style>
    `);
  }).catch();

  let validate_gwp = () => {
    let cart_subtotal = parseInt(document.querySelector('#CartDrawer .cart__items').getAttribute("data-cart-subtotal"))
    let threshold_met = cart_subtotal >= 5000;
    let gwp_item_in_cart = false;

    let cart_items = document.querySelectorAll('#CartDrawer .cart__item');
    for(let i = 0; i < cart_items.length; i++){
      
      let cart_item_var_id = parseInt(cart_items[i].getAttribute('data-key').split(":")[0])
      if(cart_item_var_id == 41781151858724){
        gwp_item_in_cart = true;
      }
      
      if(i == cart_items.length -1){

        if(threshold_met && !gwp_item_in_cart){
        
          document.documentElement.classList.add("js-add-gwp");
          return true;   
        
        } else {
          
          document.documentElement.classList.remove("js-add-gwp"); 
          return false;     
          
        }
        
      }
    }

  }

  observeSelector('#CartDrawer .cart__item', () => {
    validate_gwp()
  })

  observeSelector('#CartDrawer button[name="checkout"]', checkout_btn => {
    checkout_btn.addEventListener("click", (e) => {
      e.preventDefault();
      window.location.href = validate_gwp() ? "/cart/add?items[][id]=41781151858724&items[][quantity]=1&return_to=/checkout" : "/checkout";
    });
  })
  
}

/* 
[PEACH-13] Buy 4 Get 1 Popup -- 0.02 
*/

// PSA - THIS TEST HAS 2 PARTS!!
// 1 - the redirect is running from the tool + setting a storage item for the progress bar
// 2 - progress bar is running from proteus-treatments.js.liquid


/* START POSTSCRIPT */
// postscriptPopup event is no longer firing with the new popup beta
// - when redirect from the tool fires in v1, we're setting a sessionStorage item


// https://peachybbies.com/collections/all?promo=buy4get1-active
// https://peachybbies.com/collections/all?promo=buy3get1-active

if(getParam("promo").indexOf("get1-active") > -1){
  window.sessionStorage.setItem('peach13', getParam("promo"));
  
  // prevent the unrelated v0 popup from also firing
  document.cookie = '_ps_pop_21953cd2-92e8-4a5f-927f-c4c86eb30314=r';
}


waitUntil(() => {
	return window.sessionStorage.getItem('peach13');
}).then(() => {

    // default to 4g1
    let incrementThreshold = 5;
    let discount_code = "BUY4GET1FREE"
    if(window.sessionStorage.getItem('peach13') == "buy3get1-active"){
      incrementThreshold = 4;
      discount_code = "BUY3GET1FREE"
    }

	window.dataLayer = window.dataLayer || [];
		
		dataLayer.push({
			'event': 'proteus_custom_event',
			'proteus_event_name': `PS impression - PEACH-13 v1`,
			'proteus_event_category': "CRO",
			'page_location': window.location.href
		});
	
		// the bar is an adaptation from PEACH-08's bar - visually identical, logical requirements were super different
	
		waitForElement('#CartDrawer .drawer__inner').then(cart_content => {
			// higher level styles
			if (!document.querySelector('#peach13-styles')) document.head.insertAdjacentHTML('beforeend', `
				<style id="peach13-styles">				
					[data-peach13-discount-eligible="false"] .peach13-btn {
						display: none !important;
					}
	
					[data-peach13-discount-eligible="true"] .peach13-btn + button {
						display: none !important;
					}
				</style>
			`);
	
	
			// progress bar styles
			if (!document.querySelector('.js-progress-bar')) cart_content.insertAdjacentHTML("beforebegin", `
				<style>
				.js-progress-bar{
					text-align: center;
				}
	
				@media(max-width: 1440px){
					.js-progress-bar{
						margin: -1rem 0 1rem 0;
					}
				}
				
				.js-progress-bar--message{
					/* font-family: 'boldenvan', sans-serif; */
					font-size: 16px;
					text-align: center;
					text-transform: uppercase;
					font-weight: 700;
					margin-bottom: .5rem;
				}
				.js-progress-bar--container{
					border: 2px solid #282828;
					background: #fff;
					border-radius: 25px;
					overflow: hidden;
				}
				.js-progress-bar--filled{
					background: #ffcad5;
					width: 0;
					height: 10px;
					transition: .5s ease width;
				}
				@media(max-width: 991px){
					.js-progress-bar{
						margin: 0;
						padding: 1.5rem 30px;
						border-bottom: 2px solid;
						text-align: center;
						background: #fff4f7;
					}
				}
				</style>
				<div class="js-progress-bar">
					<div class="js-progress-bar--message"></div>
					<div class="js-progress-bar--container">
						<div class="js-progress-bar--filled"></div>
					</div>
				</div>
			`);
	
			
			// check for cart updates every .5s
			setInterval(() => {
				let threshold = incrementThreshold; // starting value
				let qualifyingItems = 0;
	
				const cartItems = cart_content.querySelectorAll('.cart__item');
					cartItems.forEach(item => {
					// non-slime items don't have this el
					const itemVariants = item.querySelector('.cart__item--variants');
					const itemQtyInput = item.querySelector('input.js-qty__num');
					// has items && and a qty - originally was excluding bundles but they are not excluded from the targeted collection in the discount
					if (itemVariants && itemQtyInput.value) {
						const qty = parseInt(itemQtyInput.value);
						qualifyingItems += qty;
	
						// reset the progress bar to countdown towards next free item
						if (qualifyingItems > threshold) {
							threshold *= Math.ceil(qualifyingItems / incrementThreshold);
						} else {
							threshold = incrementThreshold;
						}
	
						// dynamic copy
						const freeSlimes = threshold / incrementThreshold;
						const incentiveCopy = `${freeSlimes} FREE SLIME${freeSlimes > 1 ? 'S' : ''}`;
						const message_text = `You are ${threshold - qualifyingItems} slimes away from ${incentiveCopy}!`;
	
						const message = document.querySelector('.js-progress-bar--message');
						const bar_filled = document.querySelector('.js-progress-bar--filled');
	
							message.innerHTML = qualifyingItems < threshold ? message_text : `✨ Congrats! You get ${incentiveCopy}! ✨`
							bar_filled.style.width = `${(qualifyingItems / threshold) * 100}%`;
						// console.log('[PEACH-13] qualifying items', qualifyingItems);
	
						// update checkout button
						const fakeButton = document.querySelector('.peach13-btn');
						const checkoutButton = document.querySelector('button.cart__checkout');
						if (fakeButton && checkoutButton) {
								fakeButton.textContent = checkoutButton.textContent;
						}
	
						// scoping for CSS - activates discount as soon as initial threshold is met
						document.body.setAttribute('data-peach13-discount-eligible', qualifyingItems >= incrementThreshold);
					}
	
				});
			
			}, 500);
	
			// adding a fake button with the discount code - will hide/show with CSS
			waitForElement('button.cart__checkout').then(checkoutButton => {
	
				const discountCheckout = document.createElement('a');
					discountCheckout.href = `/discount/${discount_code}?redirect=/checkout`;
					discountCheckout.setAttribute('class', 'btn cart__checkout peach13-btn');
					discountCheckout.textContent = checkoutButton.textContent;
				
				if (!document.querySelector('.peach13-btn')) checkoutButton.insertAdjacentElement('beforebegin', discountCheckout);
	
			}).catch();
	
	
	
		}).catch();
	
}).catch();

// cart toggle for proteus-38
document.addEventListener('click', function (e) {
  console.log('clicked', e.target); // Debug

  const viewCartButton = e.target.closest('.peach38-view-cart-btn');
  if (viewCartButton) {
    console.log('Matched peach38-view-cart-btn');

    e.preventDefault();

    document.dispatchEvent(new CustomEvent('cart:open'));
    console.log('cart:open triggered');
  }
});


/* END POSTSCRIPT */
